import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Legacy Emergent OAuth callback. Direct Google OAuth now uses a popup flow via
 * @react-oauth/google and does NOT redirect here. This route is kept as a
 * safety net for stale bookmarks / Google Cloud console redirect URIs — it
 * simply sends the user back to /login.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/login", { replace: true });
  }, [navigate]);
  return (
    <div className="min-h-screen grid place-items-center bg-brand-navy text-white">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-brand-gold mx-auto" />
        <p className="mt-4 font-heading text-lg">Redirecting…</p>
      </div>
    </div>
  );
}
